import { FC } from 'react';

import _ from 'lodash';
import { useFormContext } from 'react-hook-form';

import { FormLabel } from 'components/FormLabel/FormLabel';
import { MIDLINE, MIDLINE_VALUES } from 'constants/prescriptionOptions';
import { translate } from 'utils';

import ImproveMidline from './ImproveMidline';
import { If } from '../Generics';
import RhfRadioGroup from '../RadioGroup/RhfRadioGroup/RhfRadioGroup';

interface Props {
  isDisabled?: boolean;
}
const Midline: FC<Props> = ({ isDisabled }) => {
  const {
    watch,
    formState: { errors }
  } = useFormContext();
  const watchMidline = watch(
    'treatmentSpecifications.ZenClearUltra.midline.Midline'
  );
  const fieldError = _.get(
    errors,
    'treatmentSpecifications.ZenClearUltra.midline'
  );
  return (
    <div>
      <FormLabel
        label={translate('prescription.step13_midline')}
        className='md:text-17px mb-4'
        error={!!fieldError}
        name={'midline'}
      />
      <RhfRadioGroup
        inputProps={{ disabled: isDisabled }}
        options={MIDLINE}
        name='treatmentSpecifications.ZenClearUltra.midline.Midline'
        className='mt-2 flex flex-row space-x-16'
        radioClassName='border-RADIO_BORDER'
        radioItemFont='md:text-17px text-sm '
      />
      <If condition={watchMidline === MIDLINE_VALUES.IMPROVE}>
        <div className='bg-GRAY5 p-4 rounded-2xl w-full'>
          <ImproveMidline isDisabled={isDisabled} />
        </div>
      </If>
    </div>
  );
};
export default Midline;
